/*
 * @Author: lyx
 * @Date: 2024-06-19 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-06-19 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P24/chart.js
 */

import { min } from "lodash";
import { toVisualThousands } from "../utils";
// import { drop, _.reverse } from 'lodash';
import getGap from '../getGap'

import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


function reverseExceptFirst(arr) {
  // 获取除第0项以外的所有项
  var rest = arr.slice(1);
  // 将这些项倒序
  rest.reverse();
  // 将第0项和倒序后的项连接回数组
  return [arr[0]].concat(rest);
}
function getChartsData(arr) {
  let barData = []  // 柱状图数据 x轴
  let lineData = [] // 折线图数据 x轴
  let dateData = [] // 日期 y轴
  // 遍历数组中的每个子数组
  for (let index = 0; index < arr.length; index++) {
    const subArray = arr[index];
    if (index === 0) {
      continue
    }
    dateData.push(subArray[0])
    //柱状图数据除以1百万
    // const result = subArray[1] / 1000000;
    // var roundedResult = Math.round(result * 100) / 100;
    // barData.push(Number(roundedResult))

    barData.push(Number(subArray[1]))
    lineData.push(Number(subArray[2]))
  }
  return [barData, lineData, dateData]
}


export default ({ label, list = [], color = [] }) => {
  let colorArr = color;
  // let arr = reverseExceptFirst(list)
  let arr = list;
  let singleArr = getChartsData(arr)
  const realBar = getGap(singleArr[0], { split: 5 })
  const realLine = getGap(singleArr[1], { split: 5 })
  const min = Math.ceil(realBar.min * realLine.max / realBar.max)
  console.log(color);
  return {
    title: {
      text: '蒙牛',
      left: '95%',
      bottom: '25%',
      textStyle: {
        color: '#ffc000',
        fontSize: 22,
        fontWeight: 'bold'
      }
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    color,
    legend: {
      show: false,
      right:'0',
      itemWidth: 20, // 设置图例项的宽度
      itemHeight: 10, // 设置图例项的高度
      textStyle: {
        fontSize: 10,
      },
      // data:['单日口碑价值(上轴)','单日内容条数(下轴)']
    },
    grid: {
      top: '3%',
      left: '2%',
      right: '8%',
      bottom: '7%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      axisLabel: {show: false, ...xAxisLabelColor, fontSize: 14, },
      data: singleArr[2] || [],
      axisTick: { show: false },
      axisLine: { show: false },
    },
    yAxis: [
      {
        type: 'value',
        name: '',
        axisLabel: {...yAxisLabelColor, fontSize: 12, color: '#595959'},
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        scale: true, // 设置y轴从零开始
        min: realBar.min,
        max: realBar.max,
        inverse: true
      },
      {
        type: 'value',
        name: '',
        axisLabel: {
          margin: 100 // 设置刻度标签与轴线的距离为20
        },
        axisLabel: { ...yAxisLabelColor, fontSize: 12, color: '#595959'},
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
        scale: true, // 设置y轴从零开始
        min: min,
        max: realLine.max,
        inverse: true

      }
    ],
    series: [
      {
        name: 'DB值',
        type: 'bar',
        yAxisIndex: 0,
        data: singleArr[0],
        
      },
      {
        name: '内容条数',
        type: 'line',
        yAxisIndex: 1,
        symbol: "none",
        data: singleArr[1],
        label: {
          show: true,
          // color: colorArr[2],
          color: '#000',
          formatter: (ele) => toVisualThousands(ele.value),
        }
      }
    ],
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P35/chart2.js